/**
 * @file 开始使用页入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { useCallback } from 'react';
import { Tabs } from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Banner from '../../components/banner/Banner';
import Footer from '../../components/footer/footer';
import QuickPane from './pages/quick/Quick';
import OldDocPane from './pages/old/OldDoc';

import QuickOnhand from './components/quick-onhand/QuickOnhand';
import Guide from './components/guides/Guides';
import ReactStickyPolyfill from '../../components/react-sticky-polyfill/ReactStickyPolyfill';

import { useHistory, useRouteMatch } from 'react-router-dom';

const Install: React.FC = () => {
    const match = useRouteMatch();
    const history = useHistory();
    const tabActiveKey = match.path;
    const onTabActiveKeyChange = useCallback((key: string) => {
        history.push(key);
        if ((window as any)._hmt) {
            if (key === '/install/old') {
                (window as any)._hmt.push(['_trackEvent', '安装', 'tab', '点击旧版本安装']);
            }
            else if (key === '/install/next') {
                (window as any)._hmt.push(['_trackEvent', '安装', 'tab', '下一步做什么']);
            }
        }
    }, [history]);

    return (
        <div className="page paddle-install-page">
            <Header />
            <Banner
                title="开始使用"
                subtitle="用飞桨来实现您的AI想法"
            />
            <ReactStickyPolyfill>
                <div className="paddle-install-page-tabs-wrap">
                    <Tabs
                        className="paddle-install-page-tabs"
                        activeKey={tabActiveKey}
                        onChange={onTabActiveKeyChange}
                    >
                        <Tabs.TabPane tab="快速安装" key="/install/quick">
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="旧版本安装" key="/install/old">
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="下一步做什么" key="/install/next">
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </ReactStickyPolyfill>

            <div className="paddle-install-page-container">
                <Tabs
                    className="paddle-install-page-tabs-body"
                    activeKey={tabActiveKey}
                    animated={false}
                >
                    <Tabs.TabPane tab="快速安装" key="/install/quick">
                        <QuickPane />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="旧版本安装" key="/install/old">
                        <OldDocPane />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="下一步做什么" key="/install/next">
                        <div className="paddle-install-page-subcontainer">
                            <div className="paddle-context-h2">
                                快速上手
                            </div>
                            <div className="paddle-context-h3">
                                尝试用 Paddle Fluid 解决一些深度学习经典问题
                                <a
                                    href="/documentation/docs/zh/beginners_guide/basics/index_cn.html"
                                >查看更多</a>
                            </div>
                            <QuickOnhand />

                            <div className="paddle-context-h2">
                                新手指南
                            </div>
                            <Guide />
                        </div>
                    </Tabs.TabPane>
                </Tabs>
            </div>
            <Footer />
        </div>
    );
};

export default Install;
